import ko from 'knockout';
import Base from '@bingads-webui-static-legacy/bulk-edit/viewmodel/bulkEditJob';
import pageContext from '@bingads-webui-static-legacy/page-context';

export default class ViewModel {
  constructor() {
    Base.call(this);
    this.showPreviewButton = ko.observable(false);
    this.isNewAudienceEnabled = pageContext.Permissions.IsNewAudienceEnabled;

    this.validate = () => {
      return true;
    };
  }
}
